export * from './DesktopVerticalTabMenuItem';
